<template>
  <!-- tabla de pagares  -->
  <b-overlay
    :show="isBusyTable"
    rounded="sm"
  >
    <!-- Tabla de ordenes -->
    <b-card
      v-show="!errorContent.table"
      no-body
      class="mb-0"
    >
      <transition name="fade-bottom">
        <section>
          <!-- Table Top -->
          <filtro-planes
            :plan-filter.sync="configRequest.wsParams.plan"
            :status-filter.sync="configRequest.status"
            :pagares-options="[{ label: 'Pendiente', value: 'PND' }, { label: 'Pagado', value: 'PAG' }]"
            :search-query.sync="searchQuery"
            :per-page.sync="perPage"
            :per-page-options="perPageOptions"
          />
          <!-- table -->
          <b-table
            ref="refDataListTable"
            class="position-relative"
            :items="fetchData"
            responsive
            :fields="tblColumFull"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="No se encontraron resultados, utilice los filtros."
            :sort-desc.sync="isSortDirDesc"
          >
            <!-- acciones -->
            <template #cell(actions)="data">
              <div class="text-nowrap">
                <!-- ver orden -->
                <b-link
                  v-show="orden === null"
                  class="font-weight-bold text-secondary"
                  @click="LinkReady(data.item.IdOrden)"
                >
                  <feather-icon
                    :id="`aspi-row-${data.item.IdOrden}-detalle-icon`"
                    icon="CoffeeIcon"
                    class="text-success cursor-pointer mr-1"
                    size="16"
                  />
                </b-link>
                <!-- send remainder -->
                <b-link
                  class="font-weight-bold text-secondary"
                  @click="mailRemainder(data.item)"
                >
                  <feather-icon
                    :id="`aspi-row-${data.item.IdPagare}-reenviar-icon`"
                    icon="MailIcon"
                    class="text-Secondary cursor-pointer mr-1"
                    size="16"
                  />
                  <b-tooltip
                    title="Remaninder"
                    :target="`aspi-row-${data.item.IdPagare}-reenviar-icon`"
                  />
                </b-link>
              </div>
            </template>
            <!-- matricula -->
            <template #cell(matricula)="row">
              <b-badge
                :variant="(row.item.persona_fk) ? 'light-primary' : 'light-warning' "
              >
                {{ (row.item.persona_fk) ? 'Inscripcion' : row.item.matricula }}
              </b-badge>
            </template>

            <template #cell(estado)="row">
              <b-badge :variant="frmstatus(row.item.estado).color">
                {{ frmstatus(row.item.estado).text }}
              </b-badge>
            </template>

            <template #cell(fecha_vence)="data">
              <b-media vertical-align="center">
                <small>{{ timestampToDate(data.item.fecha_vence, 'lll') }}</small>
              </b-media>
            </template>

            <template #cell(monto)="data">
              <b-media vertical-align="center">
                <small>{{ formatMoney(data.item.monto) }}</small>
              </b-media>
            </template>

          </b-table>
          <!-- Table's footer & pagination -->
          <div class="mx-2 mb-2">
            <b-row>
              <!-- Leyenda de cuantos elementos se muestran -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >

                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalItems"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>

              </b-col>
            </b-row>
          </div>
        </section>
      </transition>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BTable,
  BBadge,
  BLink,
  BMedia,
  BCard,
  BOverlay,
  // BInputGroup,
  // BInputGroupPrepend,
  // BFormInput,
  BPagination,
  BTooltip,
} from 'bootstrap-vue'
import { frmstatus, timestampToDate, formatMoney } from '@core/utils/filter'
import { shipcode } from '@core/utils/utils'
import { rolesActions } from '@core/mixins/account-data/roles'
import store from '@/store'
// import vSelect from 'vue-select'
import {
  ref, onMounted, watch, getCurrentInstance,
} from '@vue/composition-api'
// import { useToast } from 'vue-toastification/composition'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import hostname from '@core/utils/http/config-hostname'
import { configTablePagares } from './useComprasList'
import filtroPlanes from '../components/FiltroPlanes.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BBadge,
    BLink,
    BMedia,
    BCard,
    BOverlay,
    BPagination,
    BTooltip,
    filtroPlanes,
  },
  mixins: [rolesActions],
  props: {
    personaFk: {
      type: Number,
      default: () => null,
    },
    orden: {
      type: Number,
      default: () => null,
    },
    tview: {
      type: Number,
      default: () => 1,
    },
  },
  setup(props) {
    const errorContent = ref({ filters: false, table: false })
    const { tblColumFull, configRequest } = configTablePagares()
    const vm = getCurrentInstance().proxy
    const {
      //* Fetching data
      fetchData, refetchData, refDataListTable, dataAux,
      //* Pagination
      dataMeta,
      //* Table dynamic params
      dynamicParamRequest,
      //* Basic filters & pagination
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc,
      //* Loader
      isBusyTable,
      //* Error
      errorRequest,
    } = useFillDataTable()
    isSortDirDesc.value = false

    // preparar link for refresh
    const LinkReady = idOrden => {
      vm.$swal({
        html: `Hola, usted saldra de la solicitud actual para ir a la solicitud: <br /> <b>"${idOrden}"</b>`,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'No, mantenerme aqui.',
        confirmButtonText: 'Si, continuar',
        customClass: {
          confirmButton: 'btn btn-sm btn-primary',
          cancelButton: 'btn btn-sm btn-warning mr-1',
        },
        reverseButtons: true,
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const routeData = `${hostname().host}/app/compras/${(store.state.cuenta.rolSelected.id !== 1) ? 'ordenes/preview' : 'preview'}/${shipcode(idOrden)}/`
          window.location.replace(routeData)
        }
      })
    }
    // mail remainder
    const mailRemainder = obj => {
      vm.$swal.fire({
        title: '<strong>Remainder</strong>',
        html: `Hola, enviar recordatorio a la solicitud <br /> <b>"${obj.IdOrden}"</b> ?`,
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Enviar',
        customClass: {
          confirmButton: 'btn btn-sm btn-primary',
          cancelButton: 'btn btn-sm btn-warning mr-1',
        },
        reverseButtons: true,
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          isBusyTable.value = true
          store.dispatch('compras/postCompras', { solicitud: obj.IdOrden, action: 36 })
            .then(response => {
              isBusyTable.value = false
              vm.$swal.fire(
                'Good job!',
                response.message,
                'success',
              )
              isBusyTable.value = false
            }, error => {
              // loader.value.factura = false
              isBusyTable.value = false
              vm.$swal.fire(
                'Atención!',
                error,
                'error',
              )
            })
        }
      })
    }

    watch(errorRequest, error => { if (error) errorContent.value.table = error })
    // watch(configRequest.value, () => { refetchData(true) })
    watch([() => configRequest.value.wsParams.plan, () => configRequest.value.status], ([plan, status]) => {
      if (plan != null && status == null) {
        refetchData(true) // call api
      } else if (status != null && plan != null) {
        refetchData(false)
      } else if (plan == null && status == null) {
        refetchData(true) // seteamos vacia la lista
      }
    }, { immediate: true })

    onMounted(
      () => {
        if (props.personafk != null) {
          configRequest.value.wsParams.personafk = props.personaFk
        }
        if (props.orden != null) {
          configRequest.value.wsParams.orden = props.orden
        }
        dynamicParamRequest.value = configRequest.value
      },
    )

    return {
    // config table
      fetchData,
      tblColumFull,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      dataAux,
      isBusyTable,
      configRequest,
      // functions
      LinkReady,
      frmstatus,
      shipcode,
      timestampToDate,
      formatMoney,
      mailRemainder,
      // Error
      errorContent,

    }
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
